var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoucherIcon = function SvgVoucherIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "VoucherIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2.585a1.5 1.5 0 0 0 0 2.83V12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.415a1.5 1.5 0 0 0 0-2.83z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15 6.585.333.943.667-.235v-.708zm0 2.83h1v-.708l-.667-.235zm-14 0-.333-.943L0 8.707v.708zm0-2.83H0v.708l.667.235zM3 1a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1zm10 0H3v2h10zm3 3a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1zm0 2.585V4h-2v2.585zM15 8a.5.5 0 0 1 .333-.472l-.666-1.885A2.5 2.5 0 0 0 13 8zm.333.472A.5.5 0 0 1 15 8h-2a2.5 2.5 0 0 0 1.667 2.358zM16 12V9.415h-2V12zm-3 3a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1zM3 15h10v-2H3zm-3-3a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1zm0-2.585V12h2V9.415zM1 8a.5.5 0 0 1-.333.472l.666 1.886A2.5 2.5 0 0 0 3 8zm-.333-.472A.5.5 0 0 1 1 8h2a2.5 2.5 0 0 0-1.667-2.357zM0 4v2.585h2V4z",
    mask: "url(#VoucherIcon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.5 4.5v7"
  })));
};
export default SvgVoucherIcon;